{
  "title": "Comprobador de configuración",
  "subtitle": "Qué es realmente cierto sobre la ruta de correo de este inquilino, y qué nadie ha comprobado.",
  "loadError": "No se pudieron cargar los resultados de las pruebas",
  "runChecks": "Ejecutar comprobaciones",
  "pass": "Correcto",
  "fail": "Fallido",
  "skip": "No ejecutado",
  "warn": "Aviso",
  "ignored": "Ignorado",
  "history": "Historial de ejecuciones",
  "pasteReport": "Pegar un informe",
  "pasteHint": "Pega la salida de Test-TenantMailFlow.ps1 para registrar la evidencia del conector de Exchange.",
  "submitReport": "Enviar informe",
  "groupDns": "DNS",
  "groupM365": "Microsoft 365",
  "groupGoogle": "Google Workspace",
  "groupMailPath": "Ruta de correo",
  "noteDns": "Comprobado desde aquí, contra DNS público por DNS-over-HTTPS. Son las comprobaciones que la plataforma puede hacer por sí misma de verdad.",
  "noteM365": "Los conectores y las reglas de transporte de Exchange no tienen Graph API, y esta versión no tiene cliente Graph en absoluto. Toda respuesta de este grupo proviene de un informe Test-TenantMailFlow.ps1 que un operador ha pegado.",
  "noteGoogle": "La integración con Google Workspace aún no existe en este código. Estas filas están aquí para que esa ausencia sea visible y no silenciosa: ninguna pasará hasta que se construya la integración.",
  "noteMailPath": "La plataforma comprobándose a sí misma: su propio listener, sus propios certificados y su propia entrega de instantáneas.",
  "loopbackBlocking": "El loopback del smart host está fallando. Arréglalo antes de promover a toda la organización: el correo saliente rebotaría.",
  "loopbackTitle": "El smart host resuelve a loopback",
  "checkedAge": "Comprobado hace {{age}}.",
  "checksFailedTitle": "{{count}} comprobaciones fallidas",
  "checksFailedBody": "Una comprobación fallida significa que la ruta de correo de este inquilino está mal configurada ahora, no que podría estarlo más adelante. Usa Ignorar en una fila solo cuando el fallo sea ruido conocido para este inquilino.",
  "checksSkippedTitle": "{{count}} comprobaciones no se ejecutaron",
  "checksSkippedBody": "Este inquilino no está verificado. Las comprobaciones siguientes marcadas como «no ejecutado» no tienen ningún resultado: no están pasando en silencio, y su ausencia solo indica que nadie las ha revisado.",
  "ignore": "Ignorar",
  "unignore": "Dejar de ignorar",
  "sourceAutomated": "Automatizado",
  "sourcePasted": "Informe pegado",
  "sourceServer": "Servidor",
  "sourceUnknown": "Desconocido",
  "provenancePasted": "pegado",
  "provenanceSkipped": "omitido en una ejecución",
  "provenanceChecked": "comprobado",
  "groupNothingRan": "Nada de este grupo se ha comprobado. Estas filas no están pasando en silencio: nunca se ejecutaron.",
  "groupNoResults": "Aún no hay resultados. Ejecuta este grupo o pega un informe que lo cubra.",
  "tookMs": "Tardó {{ms}} ms.",
  "ignoreHintFail": "Excluye este fallo de los totales y las puertas. Persiste entre reejecuciones.",
  "ignoreHintWarn": "Excluye este aviso de los totales y las puertas. Persiste entre reejecuciones.",
  "pasteTitle": "Pegar un informe de Test-TenantMailFlow",
  "pasteIntro": "Prefiere Ejecutar validación automatizada arriba cuando la aplicación del conector pueda alcanzar Exchange. Pegar sigue siendo el recurso de emergencia: ejecútalo en una sesión de Exchange Online conectada al cliente y pega el JSON que imprimió.",
  "scriptTitle": "Test-TenantMailFlow.ps1",
  "scriptDescription": "Solo lectura. Consulta DNS público en vivo por DNS-over-HTTPS en lugar del resolvedor de la máquina, para que una respuesta de horizonte dividido no parezca tranquilizadora.",
  "reportJson": "JSON del informe",
  "reportJsonDescription": "Todo desde la llave de apertura hasta la de cierre.",
  "reportJsonPlaceholder": "{ \"Organization\": \"contoso.onmicrosoft.com\", \"Checks\": [ ... ] }",
  "reportInvalidTitle": "Este informe no se puede archivar",
  "reportCompleteTitle": "El informe parece completo",
  "reportSummary": "{{checks}} comprobaciones de {{organization}}, ejecutadas {{when}}: {{pass}} correctas, {{warn}} avisos, {{fail}} fallidas, {{skip}} no ejecutadas.",
  "fileError": "No se pudo archivar el informe",
  "fileReport": "Archivar este informe",
  "filed": "Informe archivado para este inquilino.",
  "filePermissionHint": "Un informe archivado se convierte en la evidencia de este inquilino, así que los administradores del inquilino y roles superiores pueden archivar uno. Ejecutar el comando y leer la salida no requiere ningún rol.",
  "historyWhen": "Cuándo",
  "historySource": "Origen",
  "historyResult": "Resultado",
  "historyEmpty": "Este inquilino nunca se ha comprobado.",
  "historyPass": "{{count}} correctas",
  "historyWarn": "{{count}} avisos",
  "historyFail": "{{count}} fallidas",
  "historySkip": "{{count}} no ejecutadas"
}
